import { axiosApi } from "./helper";

export function getConfig() {
  return axiosApi("config", {}, "get", {}, { ispublic: true });
}

export function getSsoRetailerList() {
  return axiosApi("sso/retailer", {}, "get",{},{ ispublic: true });
}

export function getShopConfig() {
  return axiosApi("config/shop", {}, "get", {});
}
